import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { formatDateLong } from '~/services/TimeService';

import { titleCase } from '~/utils/stringUtils';

import { getOrderItemDates } from './getOrderItemDates';

const orderDateFormatter = (params: GridRenderCellParams<App.Order>) => {
  const order = params.row;
  const orderItemsAggregate = getOrderItemDates(order);

  if (orderItemsAggregate.length === 0) {
    return <Typography>No dates</Typography>;
  }

  return (
    // TODO: Refractor this to be better if this grows.
    // TODO: Export the status type and backend service, and use it here.
    <Stack
      direction="column"
      key={`${order.id_orders}-check-in`}
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {orderItemsAggregate.map((orderItem, index) => (
        <Box
          key={`${orderItem.name}-${orderItem.type}-${index}`}
          sx={{
            marginBottom: 1,
          }}
        >
          {orderItem.type !== 'accommodation' && orderItem.type !== 'experience' && (
            <Typography fontWeight="bold" component="span">
              {`${titleCase(orderItem.type.replace(/_/g, ' '))}:`}
            </Typography>
          )}
          {(orderItem.type === 'accommodation' || orderItem.type === 'experience') && (
            <Typography
              fontWeight="bold"
              title={orderItem.name}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {orderItem.name}
            </Typography>
          )}
          {orderItem.date === undefined ? (
            <Typography>No Date</Typography>
          ) : orderItem.status === 'cancelled' ? (
            <Typography sx={{ textDecoration: 'line-through' }}>{formatDateLong(orderItem.date)}</Typography>
          ) : (
            <Typography>{formatDateLong(orderItem.date)}</Typography>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default orderDateFormatter;
